import styled from "styled-components";

export const BarContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const BarTrack = styled.div`
  flex: 1;
  height: 6px;
  background: #f1f5f9;
  border-radius: 3px;
  overflow: hidden;
`;

export const BarFill = styled.div`
  width: ${({ $pct }) => $pct}%;
  height: 100%;
  background: ${({ $color }) => $color};
  border-radius: 3px;
  transition: width 0.4s ease;
`;

export const BarLabel = styled.span`
  font-size: 10px;
  font-family: var(--font-mono);
  color: var(--ink-4);
  min-width: 32px;
  text-align: right;
`;
